/**
 * Functionality for (automatically) removing alert boxes
 *
 * @author Rianne Oosthoek
 */
window.alert_box = function() {
    var self = this;

    var $alert_box = $('.js-alert-box');
    var $alert_btn_close = $('.js-close');
    var $body = $('body');

    self.init = function(){
        // Fade out and remove alert box after clicking on close btn
        $alert_btn_close.click(function(e){
            e.preventDefault();
            self.removeAlertBox(true,$(this));
        });

        // Fade out and remove alert box automatically after x seconds 
        if($alert_box.hasClass('success')){
            setTimeout(function(){
                self.removeAlertBox(false);
            }, 5000);
        }
    };

    //  Method for removing the alert box
    self.removeAlertBox = function(click_event, $close_btn){
        // Does a click event take place?
        if(click_event){
            $close_btn.parent().addClass('alert-close');
        }else{
            $alert_box.addClass('alert-close');
        }
        // Remove alert box as soon as transition is done
        $alert_box.on('transitionend webkitTransitionEnd oTransitionEnd msTransitionEnd', function () {
            $(this).remove();
        });
    };
};



// WEBPACK FOOTER //
// ./resources/assets/js/frontend/components/alert-box.js